const data = [
    { id: 1, username: 'muhammad', content: 'Tweet #1' },
    { id: 2, username: 'muhammad', content: 'Tweet #2' },
    { id: 3, username: 'horun', content: 'Hello #2' },
]

export default data;